module.exports = __webpack_public_path__ + "static/requirements-hero-7d6bb7dd4835a21e8288004ce0fd55d1.png";